export default "__VITE_ASSET__870bd0b5__"